import { cn } from "@/lib/utils";
import { Lock } from "lucide-react";

// A realistic browser window chrome wrapper.
export const BrowserFrame = ({ url = "anchorwebsystems.com", theme = "light", className, children }) => {
  const dark = theme === "dark";
  return (
    <div
      className={cn(
        "overflow-hidden rounded-2xl border",
        dark ? "border-white/10 bg-navy" : "border-border bg-card",
        className
      )}
    >
      <div
        className={cn(
          "flex items-center gap-3 border-b px-3.5 py-2.5",
          dark ? "border-white/10 bg-navy-deep" : "border-border bg-secondary/70"
        )}
      >
        <div className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-[hsl(0,72%,66%)]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[hsl(45,90%,60%)]" />
          <span className="h-2.5 w-2.5 rounded-full bg-[hsl(150,55%,52%)]" />
        </div>
        <div
          className={cn(
            "flex flex-1 items-center justify-center gap-1.5 rounded-md px-3 py-1 text-[10px] font-medium",
            dark ? "bg-white/5 text-navy-muted" : "bg-background text-muted-foreground"
          )}
        >
          <Lock className="h-2.5 w-2.5" />
          {url}
        </div>
        <div className="w-10" />
      </div>
      {children}
    </div>
  );
};
